export default __webpack_public_path__ + "static/media/menu.f261ec5f.png";